export enum BetStatusEnum {
  WIN = 'Win',
  LOSE = 'Lose',
  PENDING = 'Pending',
}
